import { render, staticRenderFns } from "./CommonPrizeDrawComponent.vue?vue&type=template&id=64f3990e&scoped=true"
import script from "./CommonPrizeDrawComponent.vue?vue&type=script&lang=js"
export * from "./CommonPrizeDrawComponent.vue?vue&type=script&lang=js"
import style0 from "./CommonPrizeDrawComponent.vue?vue&type=style&index=0&id=64f3990e&prod&lang=css"
import style1 from "./CommonPrizeDrawComponent.vue?vue&type=style&index=1&id=64f3990e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f3990e",
  null
  
)

export default component.exports